import ClickAwayListener from "@mui/material/ClickAwayListener";
import Popper from "@mui/material/Popper";
import { Children, cloneElement, isValidElement, useEffect } from "react";

import "./listingActionMenu.css";

export default function ListingActionMenu({
  anchorEl,
  children,
  className = "",
  label = "Row actions",
  onClose,
  open = Boolean(anchorEl),
}) {
  useEffect(() => {
    if (!open) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [onClose, open]);

  const menuItems = Children.map(children, (child) => {
    if (!isValidElement(child)) return child;
    return cloneElement(child, {
      role: child.props.role || "menuitem",
    });
  });

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-end"
      className="listing-action-menu-popper"
      modifiers={[
        { name: "offset", options: { offset: [0, 4] } },
        {
          name: "flip",
          options: { fallbackPlacements: ["top-end"], padding: 8 },
        },
        { name: "preventOverflow", options: { padding: 8 } },
      ]}
    >
      <ClickAwayListener onClickAway={() => onClose?.()}>
        <div
          className={`listing-action-menu${className ? ` ${className}` : ""}`}
          role="menu"
          aria-label={label}
          onClick={(event) => event.stopPropagation()}
        >
          {menuItems}
        </div>
      </ClickAwayListener>
    </Popper>
  );
}
